import laptop1 from "../assets/liveProjects/forensicLaboratory/laptop1.png";
import laptop2 from "../assets/liveProjects/agrohub/laptop2.jpg";
import laptop3 from "../assets/liveProjects/teacherhub/laptop3.jpg";
import laptop4 from "../assets/liveProjects/ficha/laptop4.png";
import laptop5 from "../assets/liveProjects/primos3dprinter/laptop5.png";

import agrohub from "../assets/liveProjects/agrohub/agrohub.png";
import teacherHub from "../assets/liveProjects/teacherhub/teacherHub.png";
import forensicCriminalistic from "../assets/liveProjects/forensicLaboratory/forensicCriminalistic.png"
import ficha from "../assets/liveProjects/ficha/ficha.png";
import primos3dprinter from "../assets/liveProjects/primos3dprinter/primos3dprinter.png";

export const liveProjectsArray = [
    {
        title: "Master Degree Project",
        laptopImage: laptop1,
        image: forensicCriminalistic,
        description: "A high-end forensic laboratory environment for accident reconstruction, blending Engineering Physics with cinematic UI/UX.",
        fullStory: {
            intro: "This project represents the culmination of my work as a full-stack developer, moving beyond standard web design to create a specialized forensic laboratory environment.",
            details: [
                {
                    label: "Tactical HUD Interface",
                    text: "The application features a 'Hologram Monitor' with a grid overlay and scanline animations to mimic a military-grade forensic tool."
                },
                {
                    label: "Dynamic Data Management",
                    text: "It includes an integrated database for pedagogical references, allowing users to browse 'pedestrian' and 'vehicle' data albums."
                },
                {
                    label: "Forensic Protocol Generation",
                    text: "The system automatically generates formal 'Expertise Conclusions' that can be downloaded as professional PDF documents."
                },
                {
                    label: "Performance Optimization",
                    text: "The frontend utilizes React with staggered animations and protection logic to ensure stability during physics calculations."
                }
            ],
            reflection: "My goal was to escape the reliance on senior guidance and prove that I could implement sophisticated, independent solutions—like migrating databases from Render to Supabase to maintain service continuity. I wanted the design to feel like the 'future'—moving away from flat, boring admin panels.",
            verdict: "The presentation was a historic moment. The professors were so overwhelmed they literally cried out that 'this is the future!' They admitted their generation had reached its limit and it is time for a new generation to arise.",
            score: "96/100",
            scoreNote: "Why 96? Agh... There were some young female professors 👀"
        },
        link: ""
    },
    {
        title: "AGROHUB - Operating Tools",
        laptopImage: laptop2,
        image: agrohub,
        description: "Hypermarket Agrohub streamlines online revenue management, letting account managers and operators handle records digitally.",
        link: ""
    },
    {
        title: "Teacher Hub",
        laptopImage: laptop3,
        image: teacherHub,
        description: "An educational platform connecting parents with teachers via interactive maps and integrated PayPal payments.",
        link: "https://teacherhub.ge/"
    },
    {
        title: "Ficha.ge",
        laptopImage: laptop4,
        image: ficha,
        description: "Ficha.ge-ს Natural Honey and honey's production website landing page.",
        link: "https://maristafli.netlify.app/"
    },
    {
        title: "Primos 3D Printer",
        laptopImage: laptop5,
        image: primos3dprinter,
        description: "3D Print Craft Lab bridges the gap between digital design and tangible physical art. Specializing in high-precision FDM and resin printing, we turn custom concepts into detailed miniature keepsakes—ranging from 5 cm desktop trinkets to 20 cm custom models. Every piece is printed using durable PLA and PETG plastics engineered for fine surface layer detail.",
        link: "https://primos3dprinter.netlify.app/"
    }
]